import { render } from "./sdqzg.vue?vue&type=template&id=34aa3751&scoped=true&ts=true"
import script from "./sdqzg.vue?vue&type=script&lang=ts"
export * from "./sdqzg.vue?vue&type=script&lang=ts"

import "./sdqzg.vue?vue&type=style&index=0&id=34aa3751&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34aa3751"]])

export default __exports__